import React, { lazy } from 'react';

import type { Routes } from 'react-resource-router';

import AnalyticsContext from '@atlaskit/analytics-next/AnalyticsContext';

import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const TwgTodoHome = lazy(
	() =>
		import(/* webpackChunkName: "@atlaskit-internal_dtac-twg-todo-home" */ '../../pages/twg-todo'),
);

const TwgTodoHomeWithAccess = (): React.JSX.Element => (
	<AppAccessGate appName="TWG To-Do">
		<AnalyticsContext
			data={{ source: 'twgTodo', attributes: { page: 'twgTodo', location: 'twgTodo' } }}
		>
			<TwgTodoHome />
		</AnalyticsContext>
	</AppAccessGate>
);

export const twgTodoRoutes: Routes = [
	{
		name: 'twg-todo',
		path: '/twg-todo',
		exact: true,
		component: componentWithSuspense(TwgTodoHomeWithAccess),
	},
];
